<template>
<div id="assetChartPage">
	<div class="chartCont">
		<div class="graImg"></div>
		<div style="width:100%;height: 280px; " :id="id"></div>
		
	</div>
	<div class="assetBorder"></div>
	<div class="assetList">
		<div class="listItem" v-for="item in this.wareData">
			<div class="itemL">
				<div class="itemLegend" :style="{background:item.color}"></div>
				<div>{{ item.name }}</div>
			</div>
			<div>{{ item.value }}台</div>
		</div>
	</div>
</div>
</template>

<script>
	//引入基本模板
	let echarts = require('echarts/lib/echarts')
	//引入柱状图组件
	require('echarts/lib/chart/pie')
	//引入提示框和title组件
	require('echarts/lib/component/tooltip')
	require('echarts/lib/component/title')
	require('echarts/lib/component/graphic')
	require('echarts/lib/component/legend')
	export default{
		name:'WcAssetchart',
		props:['wareData',"id"],
		data(){
			return{
				legendData:[],
				seriesData:[],
				color:["#FB7E0D","#FF6C68","#1089D8","#12CCBE","#9DB1F8","#F8B608","#FA8D8F","#C6CD27","#D0CBEB","#C47BB2","#ECD7C6","#D0A53D","#D31528","#889A20","#7A2938","#708A93","#F1A4B6","#E86352","#E1BDC1","#E98188","#BCE3EA","#BF251D","#EF9DA1","#ECF4C3","#FEF2CC","#BC93BF","#82C0E7","#E9B87D","#F1AD98","#8B91CD"],
				total:0,
				imgUrl:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJoAAACaCAYAAABR/1EXAAAAGXRFW…ffHhQW/msndFMt/rVOFXm8qrBXLZvIHzeqXgu9Sfp/Ag",
			}
		},
		methods:{
			drawPie(){
				//基于准备好的dom ，初始化echarts实例
				let myChart = echarts.init(document.getElementById(this.id));
				myChart.clear();
				//绘制图表
				console.log("222222222222:",this.wareData);
				console.log("333333333333:",this.legendData);
				console.log("444444444444:",this.seriesData);
				
				var giftImageUrl = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJoAAACaCAYAAABR/1EXAAAAGXRFW…ffHhQW/msndFMt/rVOFXm8qrBXLZvIHzeqXgu9Sfp/Ag";
				myChart.setOption({
					title:{
						text:'安仔远程运维服务',
						textStyle:{
							color:'#FFFFFF',
							
							
						},
						x:'center',
						top:10
					},
					tooltip:{},
					/* color:['#E3623B', '#F09333', '#12CDBC', '#0E89D7', '#00FFFF', '#4AEAB0'], */
					color:this.color,
					legend: {
						show:false,
						orient: 'horizontal',
				        icon: 'circle',
				        bottom: 20,
				        x: 'center',
				        textStyle: {
				            color: '#666666'
				        },
				        //data: ["CMV7.1 070-r2801", "CMV7.1 070-r2802", "CMV7.1 070-r2803", "CMV7.1 070-r2804"],
								data:this.legendData
				    },
						graphic:[
							{
								type: 'image',
								style: {
									image: giftImageUrl,
									x: 'center',
									y: 'center',
									width: 1000,
									height: 4800
								}
							},{
								type: 'text',
								left: 'center',
								top: 'center',
								style: {
										text:this.total+"台",
										textAlign:'center',
										fill:'#FFFFFF',
										font: '16px Microsoft YaHei'
								}
							}
							
						],
					series:[{
						type: 'pie',
					        radius: ['40%', '45%'],
					        center: ['50%', '50%'],
					        /* color: ['#E3623B', '#F09333', '#12CDBC', '#0E89D7', '#00FFFF', '#4AEAB0'], */
					        labelLine: {
					            normal:{
					            	show:false
					            }
					        },
					        label: {
				                normal: {
				                    show: false,
				                    position: 'center'
				                },
				                emphasis: {
				                    show: false,
				                    textStyle: {
				                        fontSize: '30',
				                        fontWeight: 'bold'
				                    }
				                }
				            },
				            itemStyle:{
					        	normal:{
					        		borderColor :'#FFFFFF',
					        		borderWidth :1
					        	}
					        	
					        },
					        /* data: [{
					                value: 335,
					                name: '五保'
					            },
					            {
					                value: 310,
					                name: '低保'
					            },
					            {
					                value: 234,
					                name: '残疾'
					            },
					            {
					                value: 235,
					                name: '失独'
					            },
					            {
					                value: 254,
					                name: '重点优抚'
					            },
					            {
					                value: 174,
					                name: '突出贡献'
					            }
					        ], */
									//data:this.wareData.list,
									data:this.seriesData,
									/* data:[
										{value:3,name:"CMV7.1 070-r2801"},
										{value:5,name:"CMV7.1 070-r2802"},
										{value:6,name:"CMV7.1 070-r2803"},
										{value:8,name:"CMV7.1 070-r2804"}
										
									] */
					},
					{
							type: 'pie',
					        radius: ['46%', '48%'],
					        center: ['50%', '50%'],
					        color: ['#E3623B', '#F09333', '#12CDBC', '#0E89D7', '#00FFFF', '#4AEAB0'],
									//data:this.wareData.list,
									data:this.seriesData,
									/* data:[
										{value:3,name:"CMV7.1 070-r2801"},
										{value:5,name:"CMV7.1 070-r2802"},
										{value:6,name:"CMV7.1 070-r2803"},
										{value:8,name:"CMV7.1 070-r2804"}
									], */
					        /* data: [{
					                value: 335,
					                name: '五保'
					            },
					            {
					                value: 310,
					                name: '低保'
					            },
					            {
					                value: 234,
					                name: '残疾'
					            },
					            {
					                value: 235,
					                name: '失独'
					            },
					            {
					                value: 254,
					                name: '重点优抚'
					            },
					            {
					                value: 174,
					                name: '突出贡献'
					            }
					        ], */
					        labelLine: {
					            normal: {
					                show: true,
					                length: 10,
					                length2: 0,
					                lineStyle: {
					                   /* color: '#00B2C2', */
					                    width: .5
					                }
					            }
					        },
					        itemStyle:{
					        	normal:{
					        		borderColor :'#FFFFFF',
					        		borderWidth :2
					        	}
					        	
					        },
							label: {
					            normal: {
									fontSize:	'10px Microsoft YaHei',
									 /*formatter:'{b}-({c}台)'*/
					                formatter: '{c|{c}台}\n{hr|}\n{b|{b}}',
					                rich: {
					                    b: {
					                        fontSize: '10px Microsoft YaHei',
					                        color: '#808080',
					                        align: 'center',
					                        padding: [4,0,4,0]
					                    },
					                    hr: {
					                        borderColor:'#00B2C2',
					                        width: '90%',
					                        borderWidth: .5,
					                        height: 0
					                    },
					                    d: {
					                        fontSize: 8,
					                        color: '#666',
					                        align: 'center',
					                        padding: 4
					                    },
					                    c: {
					                        fontSize: 10,
					                        color: '#666',
					                        align: 'center',
					                        padding: 4
					                    }
					                }
					            }
					       },
							
				       }
					]
				})
			},
			getData(){
				this.legendData=[];
				this.seriesData=[];
				this.total=0;
				var wareData = this.wareData;
				for(var i = 0;i<wareData.length;i++){
					 this.legendData.push(wareData[i].name);
					 this.seriesData.push({value:wareData[i].value,name:wareData[i].name});
					 this.total +=parseInt(wareData[i].value);
					 //this.total +=wareData[i].value;
				}
				console.info(this.seriesData);
			
			},
			calculateHeight(){
				//获取可是区域的高度
				var clientH = document.documentElement.clientHeight;
				//头部的高度为
				var headH = 41;
				//tab的高度为
				var tabH = 44;
				//echart的画布的高度为
				var chartH = document.getElementsByClassName("chartCont")[0].clientHeight;
				//中间彩色边框的高度为
				var borerH = 4;
				//下边的列表框的高度为
				var contListH = document.getElementsByClassName("assetList")[0];
				contListH.style.height = clientH-headH-tabH-chartH-borerH-22+"px";
			},
		},
		beforeCreate:function(){
		},
		mounted:function(el){
			this.getData();
			this.drawPie();
			//this.resize();
			
		},
		watch:{
			id(newVal,oldVal){
				document.querySelector(".assetList").scrollTop=0
			}
		},
		updated:function(){
			this.getData();
			this.drawPie();
			this.calculateHeight();
		}
	}
</script>

<style>
	#assetChartPage .chartCont{
		padding:10px;
		position:relative;
	}
	#assetChartPage .graImg{
		width:80px; 
		height:80px;
		/* background:url(../../../../assets/images/assetGraphic.png) no-repeat; */
		background: url(../../../assets/images/assetGraphic.png);
		background-size:80px 80px;
		position:absolute;
		top: 0;
		left:0;
		right:0;
		bottom:0;
		margin:auto;
	}
	#assetChartPage .page-navbar .mint-tab-container-wrap{
		background: transparent;
	}
	#assetChartPage .assetBorder{
		height: 4px;
		margin-left:10px;
		margin-right:10px;
		background-image: -webkit-linear-gradient(left,#00B5C0,#019BCD);
		background-image: linear-gradient(left,#00B5C0,#019BCD);
	}
	#assetChartPage .assetList{
		margin-left:10px;
		margin-right:10px;
		border:1px solid #D0E7EF;
		/* height:auto; */
		padding: 0 15px;
		margin-bottom: 20px;
		overflow: auto;
		-webkit-overflow-scrolling: touch;
	}
	#assetChartPage .listItem{
		height: 30px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #818181;
		font-size: 14px;
	}
	#assetChartPage .itemL{
		display: flex;
		align-items: center;
	}
	#assetChartPage .itemLegend{
		width: 22px; 
		height: 9px; 
		background: red;
		margin-right: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/asset/assetChart/WcAssetchart.vue